'use strict';

var _ = require('lodash');
var validator = require('../../validator');

var $form, $continue, $requiredInputs, checkoutformValidator;

var hasEmptyRequired = function () {
    // filter out only the visible fields
    var requiredValues = $requiredInputs.filter(':visible').map(function () {
        return $(this).val();
    });
    return _(requiredValues).includes('');
};

var validateForm = function () {
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
	if($('.no-shipping-available').length > 0 ) {
		$("#primary .tax-error-message:visible").addClass('hide');        
	} else {
		if (!checkoutformValidator) {
	        return;
	    }
		var $parent = $("div.payment-method:visible, form.checkout-billing.address:visible, form.checkout-shipping.address:visible");
		var formateValidate = $parent.find(":input.required").hasClass("error");
	    $requiredInputs = $('.required', $form).find(':input');
	    if (!hasEmptyRequired() && !formateValidate) {
	            $("#primary .required-fields-warn:visible,#secondary .required-fields-warn:visible").addClass('hide');
	            $("#primary .required-shipping-warn:visible,#secondary .required-shipping-warn:visible").addClass('hide');
	    } 	

		// For card Number field validation
	    var cardValidate =  $('div.payment-method').find(".error-handle.creditcardnumber label").find('.server-error').length;
		if(cardValidate) {
			//make the cardnumber field empty if it has server error
			$('div.payment-method').find(".error-handle.creditcardnumber input.input-text").val("");
			if ($('#plcc-empty-error').hasClass('hide')) {
				$('#plcc-empty-error').removeClass('hide');
			}
		} 

		//expiry month
		var expiryMonthValidate =  $('div.payment-method').find(".error-handle.month .input-select.required:visible").hasClass('error');
		if(expiryMonthValidate) {
			//focus month field if it has server error
			if (cardValidate == 0) {
			 $('div.payment-method').find(".error-handle.month .input-select.required:visible").focus();
			}
			if($('#expiry-month-error').hasClass('hide')) {
				$('#expiry-month-error').removeClass('hide');
			}
		}

		//cvv validate
		var cvvValidate =  $('div.payment-method').find(".error-handle .input-text.cvn:input.required:visible").hasClass('error');
		if(cvvValidate) {
			if(!expiryMonthValidate) {
				$('div.payment-method').find(".error-handle .input-text.cvn:input.required:visible").focus();
			}
			if($('#cvv-error').hasClass('hide')) {
				$('#cvv-error').removeClass('hide');
			}
		}
	}
	
};

var validateEl = function () {
	if($('.no-shipping-available').length > 0 ) {
		$("#primary .tax-error-message:visible").addClass('hide');
    } else {
		if ($(this).val() === '') {
	        return;
	    } else {
	        // only validate single field
	    	if($(this).is(":visible")) {
	    		if(($(this).hasClass('error') || $(this).closest('.form-row').hasClass('error-handle')) &&  $(this).is(":focus")){
	    			validator.settings.errorClear(this);
					if ($(this).hasClass('owner')) {
						if(!$(this).closest('.form-row').next().hasClass('hide')) {
						$(this).closest('.form-row').next().addClass('hide');
						}
				    }
					if ($(this).hasClass('creditcardnumber')) {
						if(!$(this).closest('.form-row').next().hasClass('hide')) {
						$(this).closest('.form-row').next().addClass('hide');
						}
				    }
					if ($(this).hasClass('cvn')) {
						if(!$(this).closest('.form-row').next().siblings('#cvv-error').hasClass('hide')) {
						$(this).closest('.form-row').next().siblings('#cvv-error').addClass('hide');
						}
				    }
	    		}
	    		var $parent = $(this).closest("div.payment-method, form.checkout-billing.address, form.checkout-shipping.address");
	    		var formateValidate = $parent.find(":input.required:visible").hasClass("error");
	    		if (!hasEmptyRequired() && !formateValidate) {
	    			 $("#primary .required-fields-warn:visible,#secondary .required-fields-warn:visible").addClass('hide');
	    			 $("#primary .required-shipping-warn:visible,#secondary .required-shipping-warn:visible").addClass('hide');
		        }
	
	    	}
	    }	
	}
};
var completeFormMessage= function(){
	var $parent = $("div.payment-method, form.checkout-billing.address, form.checkout-shipping.address,form#checkoutCreateAccount");
	var formateValidate = $parent.find(":input.required:visible").hasClass("error");
	var formatServerValidate=$parent.find(":input.required:visible").closest('.form-row').hasClass('error-handle');
	if (hasEmptyRequired() || formateValidate || formatServerValidate ) {
    	if($('.no-shipping-available').length > 0 ) {
    		if ($("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.required-shipping-warn').length <= 0) {
    			$("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.tax-error-message').addClass('hide');
	    		$("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').prepend('<div class="required-shipping-warn">'+Resources.CHECKOUT_AVALARA_TAX_ERROR+'</div>');
	    	}
	    	if ($("#secondary .disabled-hover-event").closest('div').find('.required-shipping-warn').length <= 0) {
	    		$("#secondary .disabled-hover-event").closest('div').prepend('<div class="required-shipping-warn">'+Resources.CHECKOUT_AVALARA_TAX_ERROR+'</div>');
			}
			if($("#primary .disabled-hover-event,#secondary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.required-shipping-warn').hasClass('hide')){
				$('#primary .required-shipping-warn.hide,#secondary .required-shipping-warn.hide').removeClass('hide');	
			}
    	}else {
    		if ($("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.required-fields-warn').length <= 0) {
	    		$("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').prepend('<div class="required-fields-warn">'+Resources.CHECKOUT_REQUIRED_CONTINUE+'</div>');
			}				
	    	if ($("#secondary .disabled-hover-event").closest('div').find('.required-fields-warn').length <= 0 ) {
	    		$("#secondary .disabled-hover-event").closest('div').prepend('<div class="required-fields-warn">'+Resources.CHECKOUT_REQUIRED_CONTINUE+'</div>');
			}
			if($("#primary .disabled-hover-event,#secondary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.required-fields-warn').hasClass('hide')){
				$('#primary .ck-field-required-error-handle .required-fields-warn.hide:not(#plcc-min-length-error),#secondary  .ck-field-required-error-handle .required-fields-warn.hide').removeClass('hide');	
			}
    	}
    }
	var formatPLCCValidate = $("select[name $='_billing_paymentMethods_creditCard_type']").find('option:selected').attr("plccType") == "true"
							&& $('div.payment-method').find(":input.required:visible").hasClass('error');
	
	// For card owner field validation
	var ownerValidate =  $('div.payment-method').find(".error-handle .input-text.owner:input.required:visible").hasClass('error');
	if(ownerValidate) {
		if($('#owner-name-error').hasClass('hide')) {
			$('#owner-name-error').removeClass('hide');
		}
	}
	// For card owner field validation
	var cardValidate =  $('div.payment-method').find(".error-handle .input-text.creditcardnumber:input.required:visible").hasClass('error');
	if(cardValidate) {
		if(formatPLCCValidate) {
			if ($('#plcc-min-length-error').hasClass('hide')) {
					$('#plcc-min-length-error').removeClass('hide');
			} 
	    } else {
				if ($('#plcc-empty-error').hasClass('hide')) {
					$('#plcc-empty-error').removeClass('hide');
				}
		    }
	} 

	//cvv validate
	var cvvValidate =  $('div.payment-method').find(".error-handle .input-text.cvn:input.required:visible").hasClass('error');
	if(cvvValidate) {
		if($('#cvv-error').hasClass('hide')) {
			$('#cvv-error').removeClass('hide');
		}
	}
	//expiry month
	var expiryMonthValidate =  $('div.payment-method').find(".error-handle.month .input-select.required:visible").hasClass('error');
	if(expiryMonthValidate) {
		if($('#expiry-month-error').hasClass('hide')) {
			$('#expiry-month-error').removeClass('hide');
		}
	}
	//expiry year
	var expiryYearValidate =  $('div.payment-method').find(".error-handle.year .input-select.required:visible").hasClass('error');
	if(expiryYearValidate) {
		if($('#expiry-year-error').hasClass('hide')) {
			$('#expiry-year-error').removeClass('hide');
		}
	}
};

var init = function (opts) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    $form = $(opts.formSelector);
    $continue = $(opts.continueSelector);
    checkoutformValidator = $form.validate(validator.settings);
    $requiredInputs = $('.required', $form).find(':input');
    validateForm();
    
    // start listening
	$requiredInputs.off('change input', validateEl).on('change input', validateEl);
    
    //SM-4681 special characters validation for address-2. 
    $('body').off('focusout','.address  .address2').on('focusout','.address .address2', function() {
        if(checkoutformValidator.element(this)) {
            return false;
        }
    });    
    
    
    //ValidateEl to remove error for address-2
    $('body').off('keyup change input','.address  .address2').on('keyup change input','.address .address2',validateEl);
    
    var spcExpCheckoutElement= $(window).width()<1024 ? ":not('.spc-summary-btn')" : " ";
    
    $(".order-summary-footer .rightbutton,.checkout-tabs .button-fancy-large"+spcExpCheckoutElement).off('mouseenter touchstart').on('mouseenter touchstart',function(e) {
    	completeFormMessage();    
	});
	$('body').off('focusout','.payment-method  .input-text.error').on('focusout','.payment-method  .input-text.error', function() {
		completeFormMessage();
    }); 
	$('body').off('focusout','.payment-method  .input-text').on('focusout','.payment-method  .input-text', function() {
		if(!$(this).hasClass('error')) {
			if(!$(this).closest('.form-row').next('.required-fields-warn').hasClass('hide')) {
				$(this).closest('.form-row').next('.required-fields-warn').addClass('hide');
			}
		}
    });  
	   
};

exports.init = init;
exports.validateForm = validateForm;
exports.validateEl = validateEl;
exports.completeFormMessage = completeFormMessage;
